import React from 'react';
import { CheckIcon, ChevronDownIcon } from 'lucide-react';
import { SectionBadge } from '../SectionBadge';
import { Reveal } from '../Reveal';
import { TOMOS, TOMO_INCLUDES } from '../../data/content';
export function TomosList() {
  return <section className="w-full px-5 py-12 sm:py-16" data-id="element-259" data-mp="1vcf57hhvzwr8">
      <div className="mx-auto max-w-3xl" data-id="element-260" data-mp="20bi92ym4rwxm">
        <Reveal className="text-center" data-id="element-261" data-mp="20agmbwvr5m02">
          <p className="font-display text-3xl uppercase tracking-[0.08em] text-lime sm:text-4xl" data-id="element-262" data-mp="13kzi7mcf480h">La solución</p>
          <SectionBadge className="mt-3" data-id="element-263" data-mp="17lt4yce4jgrs">Todo en un solo lugar</SectionBadge>
          <h2 className="mt-5 font-display text-2xl leading-tight text-snow sm:text-4xl" data-id="element-264" data-mp="1cle5uscutz75">
            ¿Qué contiene <span className="u-lime" data-id="element-265" data-mp="1hc4ag3dghy0s">MegaPack Árabe PRO</span>?
          </h2>
        </Reveal>

        <div className="mt-8 space-y-2.5" data-id="element-266" data-mp="jwqfiid90jmq">
          {TOMOS.map((tomo, index) => <Reveal key={tomo.n} delay={Math.min(index, 3) * 60} data-id="element-267" data-mp="jwgocrggw6fg" data-mpi={index}>
              <details open={index === 0} className="group overflow-hidden rounded-2xl border border-ink-line bg-ink" data-id="element-268" data-mp="ourxezyxucwm">
                <summary className="flex cursor-pointer list-none items-center gap-3.5 p-4 focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-lime sm:p-5 [&::-webkit-details-marker]:hidden" data-id="element-269" data-mp="2pnr809p7ffnb">
                  <span className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full font-display text-lg text-lime" style={{
                backgroundColor: tomo.color
              }} data-id="element-270" data-mp="2gtm8l1w08vw6">
                    {tomo.n}
                  </span>
                  <span className="flex-1" data-id="element-271" data-mp="21xwudpx29n20">
                    <span className="block text-[10px] font-extrabold uppercase tracking-[0.18em] text-lime" data-id="element-272" data-mp="22115l78y1j26">
                      Tomo {tomo.n}
                    </span>
                    <span className="mt-0.5 block text-sm font-bold leading-snug text-snow sm:text-base" data-id="element-273" data-mp="1szumcqewtu58">
                      {tomo.title}
                    </span>
                  </span>
                  <ChevronDownIcon className="h-4 w-4 flex-shrink-0 text-snow-dim transition-transform duration-300 group-open:rotate-180" aria-hidden="true" data-id="element-274" data-mp="3nckfh5xgezbk" />
                </summary>

                <div className="px-4 pb-5 sm:px-5 sm:pl-[72px]" data-id="element-275" data-mp="f2rzeeqxtk4n">
                  <p className="text-sm font-semibold leading-relaxed text-snow sm:text-base" data-id="element-276" data-mp="1attecsiw4cp">{tomo.intro}</p>
                  <p className="mt-4 text-xs font-bold text-snow-dim" data-id="element-277" data-mp="6952umewocue">{tomo.listLabel}</p>
                  <ul className="mt-2.5 grid gap-x-5 gap-y-2 sm:grid-cols-2" data-id="element-278" data-mp="typqhim07ya0">
                    {tomo.items.map(item => <li key={item} className="flex items-start gap-2.5 text-sm leading-snug text-snow-muted" data-id="element-279" data-mp="y1clfsdz1zbf">
                        <CheckIcon className="mt-0.5 h-3.5 w-3.5 flex-shrink-0 text-lime" aria-hidden="true" data-id="element-280" data-mp="k1uw9bwrkk1j" />
                        {item}
                      </li>)}
                  </ul>
                  <p className="mt-4 border-t border-ink-line pt-3.5 font-display text-lg italic text-lime" data-id="element-281" data-mp="34qr5wse5poe7">
                    {tomo.closing}
                  </p>
                </div>
              </details>
            </Reveal>)}
        </div>

        <Reveal delay={110} className="mt-6" data-id="element-282" data-mp="3251di6tqggks">
          <div className="rounded-2xl border-2 border-lime bg-rose-deep p-5 sm:p-6" data-id="element-283" data-mp="2x8aw9g66zexs">
            <h3 className="font-display text-2xl text-lime" data-id="element-284" data-mp="3b7kfyptlwr6i">Cada tomo incluye</h3>
            <ul className="mt-3.5 grid gap-2.5 sm:grid-cols-2" data-id="element-285" data-mp="3b56kwgyxfeyy">
              {TOMO_INCLUDES.map(item => <li key={item} className="flex items-start gap-2.5 text-sm font-medium leading-snug text-snow sm:text-base" data-id="element-286" data-mp="366d3wekfl5u1">
                  <CheckIcon className="mt-0.5 h-4 w-4 flex-shrink-0 text-lime" aria-hidden="true" data-id="element-287" data-mp="2ehjr6qt8map7" />
                  {item}
                </li>)}
            </ul>
          </div>
        </Reveal>
      </div>
    </section>;
}